export default __webpack_public_path__ + "static/media/Group 455.73f708c3.png";